import './styles.scss'

import React from 'react'
import { useActions, useValues } from 'kea'
import { hot } from 'react-hot-loader'

import I18n from 'lib/i18n'
import Radio from 'lib/forms/radio'
import SubmitButton from 'lib/tags/submit-button'

import phoneLogic from './logic'

const Phone = () => {
  const { selectRequest, selectContact, submit } = useActions(phoneLogic)
  const { selection, isSubmitting } = useValues(phoneLogic)

  return (
    <div className='popups-phone-scene'>
      <h4 className='modal-header confirm'>{I18n.t('popups.phone.title')}</h4>
      <div className='modal-max'>
        <section>
          <Radio checked={selection === 'request'} onChange={selectRequest}>
            <span>{I18n.t('popups.phone.request')}</span>
          </Radio>
          <br />
          <Radio checked={selection === 'contact'} onChange={selectContact}>
            <span>{I18n.t('popups.phone.contact')}</span>
          </Radio>
        </section>
        <section>
          <SubmitButton isSubmitting={isSubmitting} isButtonHaveDisabledStyle={!selection} onClick={submit}>
            {I18n.t('popups.phone.button')}
          </SubmitButton>
        </section>
      </div>
    </div>
  )
}

export default hot(module)(Phone)
